<template>
    <div>
        <top-nav></top-nav>
        <top-search :isShowSearch="false"></top-search>
        <div class="main-bg">
            <div class="main-wrap">
                <slot name="crumb"></slot>
                <slot name="content"></slot>
            </div>
        </div>
        <Footers></Footers>
    </div>
</template>
<script>
    import TopNav from '../../../components/header/topNav.vue'
    import TopSearch from "../../../components/header/topSearch.vue";
    import Footers from "../../../components/footers.vue";
    export default {
        components: {TopNav,TopSearch,Footers},
        data(){
            return {

            }
        },
        computed:{

        }

    }
</script>
<style lang="scss" scoped>
    @import "../../../assets/css/common";
</style>